import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carSeat";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
